export enum AcceptableShiftsFilterType {
    NAME = 'name',
    START_TIME = 'startTime',
}
